module.exports = __webpack_public_path__ + "img/tag-expertise.5b6ec527.svg";